<template>
  <div class="home-page">
    <TopBar />
    <main class="main-content">

      <h1>AVALIAÇÃO DE CONTROLES INTERNOS</h1>

      <div class="cards" style="color: white;">

        <Button @click="navigateToMainPage('all-control-points')" style="border-radius: 5%; width: 250px; display: flex; flex-direction: column; align-items: center;">
          <i class="pi pi-list-check mt-5" style="font-size: 5rem"></i> 
          <div class="m-5" style="font-size: 1.2rem; font-weight: bold; text-align: center;">Minhas Tarefas</div>
        </Button>

        <Button @click="navigateToMainPage('pending-control-points')" style="border-radius: 5%; width: 250px; display: flex; flex-direction: column; align-items: center;">
          <i class="pi pi-bell mt-5" style="font-size: 5rem"></i> 
          <div class="m-5" style="font-size: 1.2rem; font-weight: bold; text-align: center;">Pendências</div>
        </Button>

        <Button @click="navigateToMainPage('obligations-calendar')" style="border-radius: 5%; width: 250px; display: flex; flex-direction: column; align-items: center;">
          <i class="pi pi-calendar-clock mt-5" style="font-size: 5rem"></i> 
          <div class="m-5" style="font-size: 1.2rem; font-weight: bold; text-align: center;">Calendário de Obrigações</div>
        </Button>

      </div>

    </main>
  </div>
</template>

<script setup lang="ts">

  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import TopBar from '@/components/TopBar.vue';

  const router = useRouter();

  const toggleTheme = () => {
    // Logic to toggle theme
    console.log('Theme toggled');
  };

  const logout = () => {
    // Logic to logout or view profile
    console.log('Logout or Profile clicked');
  };

  const navigateToMainPage = (menuItem) => {
    router.push({ name: 'MainPage', params: { menuItem } });
  };

</script>

<style scoped>
  .home-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background-color: #ffffff;
    border-bottom: 1px solid #dee2e6;
  }

  .logo img {
    height: 40px;
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .product-logo {
    height: 40px;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  h1 {
    font-size: 2rem;
    margin-bottom: 2rem;
  }

  .cards {
    display: flex;
    gap: 1rem;
  }

  .card {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 0.5rem;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.2s;
  }

  .card:hover {
    transform: translateY(-5px);
  }
</style>
